import React, { useCallback, useEffect, useState, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { frontloadConnect } from 'react-frontload';


import TireDetailMeta from './TireDetailMeta';
import ProductImages from '../ProductDetail/ProductImages';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import { trackEvent } from '../../components/Tracking/Matomo';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import DealerInfo from '../../components/DealerInfo/DealerInfo';
import LegacyTireLabel from '../../components/Tires/LegacyTireLabel';

import { fetchWheelDetailIfNeeded } from '../../../modules/actions/standort/wheelDetail';
import { wheelDetailResponseSelector } from '../../../modules/selectors/standort/wheelDetail';
import Currency from '../../../helpers/currency';
import { taxLabel } from '../../../helpers/taxHelper';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';
import Button from '../../components/form-elements/Button';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import Anchor from '../../components/form-elements/Anchor';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { InternalLink } from '../../components/form-elements/Link';
import { addReifen } from '../../../modules/actions/standort/session/cart';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { useHistory } from 'react-router-dom';
import { saveproduct, resetproduct } from '../../../modules/actions/productID';
import QuantityInput from '../ProductDetail/QuantityInput';
import classnames from 'classnames';
import { Offcanvas } from '../../components/Offcanvas/Offcanvas';
import { apiClient, useAsyncFunction } from '../../../helpers/apiHelperV2';
import { standortUrlSelector } from '../../../modules/selectors/url';
import MoreProductsSlider from '../ProductDetail/MoreProductsSlider';
import MoreProductsSliderCard from '../ProductDetail/MoreProductsSliderCard';
import InlineSpinner from '../../components/Spinner/InlineSpinner';
import _ from 'lodash';
import Image from '../../components/Image/Image';

// TODO: merge/refactor with ProductDetail QuantityBox
function QuantityBox({ tire, online: isOnline, lieferweg, price, isFreeShipping, setSelect, isSelected, quantity }) {
    
    return (
        <div >
            <div onClick={() => setSelect(isOnline)} className={classnames('uk-width-1 uk-margin-small', isSelected ? "uk-background-muted quality-box-card" : "uk-border uk-border-muted quality-box-card")} style={{cursor: 'pointer'}}>
                <div className="uk-flex uk-flex-between">                  
                    <div className="uk-text-small uk-text-muted uk-flex uk-flex-start">
                        <div className="uk-width-auto" style={{paddingTop: "10px" }}>
                        <input type="radio" name={`lieferweg-${tire.id}`} className="uk-radio uk-margin-right" checked={isSelected} onChange={() => {}} />

                        </div>
                        <div>
                            <span className='uk-text-left uk-text-bold' style={{'font-size': '1.375rem'}}>{isOnline ? 'Lieferung' : 'Abholung'}</span>
                        <div className='uk-margin-small'>
                            Preis inkl. {taxLabel()} MwSt.
                        </div>
                        {isOnline && (
                            isFreeShipping ? 
                            <div>
                                <InternalLink to="/versandkosten" ariaLabel="Informationen zu Versandkosten"><u className='uk-text-bold uk-text-decoration-none' style={{color:"#128001"}}>Versandkostenfrei</u></InternalLink>
                            </div> 
                            : 
                            <div>
                                zzgl. etwaiger <InternalLink to="/versandkosten" ariaLabel="Informationen zu Versandkosten"><u>Versandkosten</u></InternalLink>
                            </div>
                        )}
                        </div>
                    </div>
                    <span className="aps-price">
                        <Currency quantity={price * quantity} />
                    </span>
                </div>
            </div>  
        </div>
    )
}

function TireDetail({ tireDetail }) {
    const markenStandort = useSelector(markenStandortSelector);
    const focusBtnRef = useRef();
    const dispatch = useDispatch();
    const history = useHistory();
    const [quantity, setQuantity] = useState(1);
    const additionalCrumbs = [
        { url: `/reifen-felgen`, label: 'Reifen & Felgen' },
        {
            url: `/${tireDetail.saison.toLowerCase()}reifen`,
            label: `${tireDetail.saison}reifen`,
        },
        {
            url: `/reifen/${tireDetail.fahrzeugtyp}/${tireDetail.saison}/${tireDetail.breite}/${tireDetail.querschnitt}/${tireDetail.durchmesser}`,
            label: 'Reifenauswahl',
        },
        {
            label: 'Reifen',
        },
    ];

    const additionalInformation = tireDetail?.additionalInfo?.dotWare
        ? { label: `DOT: ${tireDetail.additionalInfo.dotWare}`, tooltip: 'DOT = Herstellungsjahr des Reifens' }
        : tireDetail?.additionalInfo?.herstellerGarantie
            ? { label: 'mit Herstellergarantie', tooltip: 'Spezielle Garantie des Herstellers' }
            : tireDetail?.additionalInfo?.demo
                ? {
                    label: 'DEMO-Reifen',
                    tooltip:
                        'Demontierte Reifen bis Max. 50km Laufleistung von Vorführ- oder Neufahrzeugen bzw. von Kompletträdern zur Winter/Sommer Saison',
                }
                : undefined;
    const vorteile = tireDetail?.onlineLieferweg?.Vorteilskommunikation ?? tireDetail?.pickupLieferweg?.Vorteilskommunikation ?? [];

    useEffect(() => {
        if (tireDetail) {
            let productID;
            productID = tireDetail.selectedBezugsquelle.artNummer;
            dispatch(saveproduct(productID));
        }
    }, [dispatch, tireDetail]);

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            // ... logic
            dispatch(resetproduct());
        });

        return unlisten;
    }, [dispatch, history]);
    const isTecar = tireDetail?.hersteller === 'TECAR';
    const online = Boolean(tireDetail?.onlineLieferweg);
    const[isOnline, setIsOnline] = useState(online && !markenStandort.isTechno);
 
       function handleAddToCart({ quantity }) {
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: tireDetail.neutralKey,
            value: (isOnline ? tireDetail.selectedBezugsquelle.onlineVK : tireDetail.selectedBezugsquelle.vk_preis) * quantity * 100,
        });
        dispatch(
            addReifen({
                reifen: {
                    ...tireDetail,
                    selectedLieferweg: isOnline ? tireDetail.onlineLieferweg : tireDetail.pickupLieferweg,
                    selectedBezugsquelle: {
                        ...tireDetail.selectedBezugsquelle,
                        vk_preis: isOnline ? tireDetail.selectedBezugsquelle.onlineVK : tireDetail.selectedBezugsquelle.vk_preis,
                    },
                },
                quantity,
            })
        );
        setSidebarVisible(true);
    }

    const handleSelect = (isOnline) => {
        if (isOnline) {
            setIsOnline(true)
        } else {
            setIsOnline(false);
            // Handle offline selection
        }
    };
    const handleQuantityInputChange = (newQuantity) => {
        setQuantity(newQuantity);
    };

    const standortUrl = useSelector(standortUrlSelector);
    const topSellerResponse = useAsyncFunction(async () => apiClient.get(`/api/v1/standorte/${standortUrl}/bestseller`), [standortUrl]);
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const [offsetTop] = useState(130);

    useEffect(() => {
        if (isSidebarVisible && focusBtnRef.current) {
            focusBtnRef.current.focus();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [isSidebarVisible]);

    const closeSidebar = useCallback(() => {
        setSidebarVisible(false);
    }, []);
 
    const handlePress = (e) => {
        e.preventDefault()
        if (e.key === "Enter") {
            closeSidebar()
        }
    }

    return (
        <>
            <TireDetailMeta tireDetail={tireDetail} />
            <BreadCrumbSelector additionalCrumbs={additionalCrumbs} />
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container uk-margin-medium-top">
                    <h1 className="uk-margin-remove">
                        {tireDetail.hersteller} {tireDetail.profil} <span className="uk-text-muted">{tireDetail.bezeichnung}</span>
                    </h1>
                    <h2 className="uk-text-light uk-margin-remove">{tireDetail.warengruppe}</h2>
                    <p>Artikelnummer: {tireDetail.selectedBezugsquelle.artNummer}</p>
                    <div className="uk-grid-small uk-child-width-1-2@s" data-uk-grid="">
                        <ProductImages variant={tireDetail} images={tireDetail.images || []} />
                        <div>
                            <div className="uk-flex uk-flex-middle uk-margin-small-bottom">
                                                <span className="uk-icon uk-icon-circle uk-text-success lieferzeit-icon-badge"></span>
                                                <span
                                                    className="uk-text-small uk-margin-small-left"
                                                    id="abholbereit-hinweis"
                                                >
                                                    {isOnline? 'Lieferzeit 3-10 Werktage' : 'Abholbereit innerhalb von 3-10 Werktage'}
                                                </span>
                                            </div>
                            <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                                {tireDetail.onlineLieferweg && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.onlineVK}
                                        lieferweg={tireDetail.onlineLieferweg}
                                        online
                                        isFreeShipping={isTecar}
                                        setSelect={handleSelect}
                                        isSelected={isOnline}
                                        quantity={quantity}
                                    />
                                )}
                                {tireDetail.pickupLieferweg && !markenStandort.isTechno && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.vk_preis}
                                        lieferweg={tireDetail.pickupLieferweg}
                                        setSelect={handleSelect}
                                        isSelected={!isOnline}
                                        quantity={quantity}
                                    />
                                )}
                                    <div className='uk-grid-small uk-flex-middle uk-padding-remove uk-margin-auto' data-uk-grid="">
                                        <div className="uk-width-1-2@l uk-width-auto uk-flex uk-flex-left@s">
                                            <div className="uk-form-controls">
                                                <QuantityInput
                                                    initialValue={1}
                                                    minValue={1}
                                                    maxValue={1111}
                                                    onChange={handleQuantityInputChange}
                                                    ariaLabel="Menge festlegen"
                                                />
                                            </div>
                                        </div>
                                        <div className="uk-width-1-3 uk-flex uk-flex-column uk-text-center uk-text-right@s uk-width-expand uk-margin-remove-top@s">
                                        <Button onClick={() => handleAddToCart({ quantity })} ariaLabel={isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}>{isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}</Button>
                                        </div>
                                    </div>
                                {tireDetail.energyLabelUrl && (
                                    <div>
                                        <div className="uk-margin-small-bottom">
                                            <TireInformationModal tire={tireDetail} />
                                        </div>
                                        <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s">
                                            <TireEnergyLabelLinks tire={tireDetail} />
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <table className="uk-table uk-table-striped uk-table-small">
                                        <tbody>
                                            <tr>
                                                <td>Hersteller</td>
                                                <td>{tireDetail.hersteller}</td>
                                            </tr>
                                            <tr>
                                                <td>Profil</td>
                                                <td>{tireDetail.profil}</td>
                                            </tr>
                                            <tr>
                                                <td>Größe</td>
                                                <td>{tireDetail.bezeichnung}</td>
                                            </tr>
                                            <tr>
                                                <td>Geschwindigkeitsindex</td>
                                                <td>
                                                    {tireDetail.speedindex} bis {speedIndexToSpeed[tireDetail.speedindex]} km/h
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Loadindex</td>
                                                <td>{tireDetail.loadindex}</td>
                                            </tr>
                                            <tr>
                                                <td>Kategorie</td>
                                                <td>{tireDetail.warengruppe}</td>
                                            </tr>
                                            <tr>
                                                <td>Zusatzinformationen</td>
                                                <td>
                                                    {additionalInformation && (
                                                        <div data-uk-tooltip={additionalInformation.tooltip}>
                                                            <i className="fa fa-info-circle" aria-hidden="true" />{' '}
                                                            {additionalInformation.label}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>DEMO-Reifen</td>
                                                <td>
                                                    {tireDetail?.additionalInfo?.demo ? 'Ja' : 'Nein'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="uk-text-muted">Lieferung ohne Felge</p>
                                </div>
                                <div>
                                    {!tireDetail.energyLabelUrl && (
                                        <ul data-uk-accordion="">
                                            <li className="uk-open">
                                                <Anchor className="uk-accordion-title">EU-Reifenlabel</Anchor>
                                                <div className="uk-accordion-content">
                                                    <LegacyTireLabel tireDetails={tireDetail} />
                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {false && (
                <section className="uk-section uk-section-muted uk-section-small">
                    <div className="uk-container">
                        <div className="uk-flex uk-flex-wrap uk-flex-center@m">
                            {vorteile.map((vorteil, i) => {
                                if (typeof vorteil === 'object') {
                                    return (
                                        <div className="uk-flex uk-flex-middle uk-margin-small-right uk-width-1-1 uk-width-auto@m" key={i}>
                                            <div
                                                className="uk-margin-small-right uk-font-main"
                                                dangerouslySetInnerHTML={{ __html: vorteil.path }}
                                            />
                                            {vorteil.text}
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className="uk-flex uk-flex-middle uk-margin-small-right uk-width-1-1 uk-width-auto@m" key={i}>
                                            <i className="fa fa-check uk-margin-small-right uk-font-main" />
                                            {vorteil}
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </section>
            )}
            <section className="uk-section uk-section-muted uk-section-small">
                <div className="uk-container uk-container-xsmall">
                    <Meisterkachel />
                </div>
            </section>
            <DealerInfo />
            <Offcanvas overlay isVisible={isSidebarVisible} onIsVisibleChange={visible => setSidebarVisible(visible)} flip={true} className="side-bar-zindex">
                <div className="uk-offcanvas-bar product-sidebar" style={{ top: offsetTop, bottom: 0, overflowY: 'auto', WebkitOverflowScrolling: 'touch', paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}>
                    <button className="uk-offcanvas-close focus" type="button" ref={focusBtnRef} data-uk-close="" onKeyPress={handlePress} onClick={closeSidebar} aria-label='Navigation schließen' aria-hidden="true" focusable="false" />
                    <span className='uk-text-bold menu-black'><i className="fa fa-check-circle" aria-hidden="true" style={{ color: "#128001" }} /> <span className='uk-margin-small-left'> Artikel wurde hinzugefügt</span></span>
                    <div className='uk-flex uk-flex-middle uk-margin-top'>
                        <div className='uk-margin-small-right'>
                            <Image src={tireDetail.images[0]} alt={tireDetail.bezeichnung} resizeHeight={120} fit="cover" />
                        </div>
                        <div className='uk-margin-small-left'>
                            <p className='headline headline-sidebar'>
                                {tireDetail.hersteller} {tireDetail.profil} <span className="uk-text-muted">{tireDetail.bezeichnung}</span>
                            </p>

                            <span className="aps-price sidebar-price">
                                <Currency quantity={(isOnline ? tireDetail.selectedBezugsquelle.onlineVK : tireDetail.selectedBezugsquelle.vk_preis) * quantity} />
                            </span>
                        </div>
                    </div>
                    <hr />
                    <ReduxSuspense response={topSellerResponse} error={null} fallback={<InlineSpinner />}>
                        {data => {
                            if (_.isEmpty(data?.data)) return null;
                            return (
                                <section className="uk-section-default uk-padding-remove-bottom">
                                    <div className="uk-container uk-margin-medium-top">
                                        <p className='menu-black'><span>Jetzt gleich mitbestellen</span></p>
                                        <MoreProductsSlider>
                                            {data.data.map(product => (
                                                <li key={product.id}>
                                                    <MoreProductsSliderCard product={product} onClose={closeSidebar} />
                                                </li>
                                            ))}
                                        </MoreProductsSlider>
                                    </div>
                                </section>
                            );
                        }}
                    </ReduxSuspense>
                    <div className="uk-flex uk-flex-column uk-text-center uk-text-right@s uk-width-expand uk-padding-small uk-margin-top-small">
                        <Button
                            className={classnames('custom-button-qualityBox-default uk-text-uppercase')}
                            type="button"
                            modifier="default"
                            onClick={() => closeSidebar()}
                            ariaLabel='WEITER EINKAUFEN'
                        >
                            WEITER EINKAUFEN
                        </Button>

                        <InternalLink to="/warenkorb" fullWidth className="uk-margin-top uk-button uk-button-primary custom-button-qualityBox uk-text-uppercase" modifier="primary" ariaLabel="ZUM WARENKORB">
                            ZUM WARENKORB
                        </InternalLink>
                    </div>
                </div>
            </Offcanvas>
        </>
    );
}

function LoadTireDetail({ wheelDetailResponse }) {
    return <ReduxSuspense response={wheelDetailResponse}>{tireDetail => <TireDetail tireDetail={tireDetail} />}</ReduxSuspense>;
}

const frontload = async props => {
    const { fetchWheelDetailIfNeeded, wheelId } = props;
    await fetchWheelDetailIfNeeded({ wheelId });
};

const mapDispatchToProps = { fetchWheelDetailIfNeeded };

const mapStateToProps = (
    state,
    {
        match: {
            params: { id: wheelId },
        },
    }
) => {
    return { wheelId, wheelDetailResponse: wheelDetailResponseSelector(state, { wheelId }) };
};

export default withStandortRouter(
    connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload, { onUpdate: true })(LoadTireDetail))
);
